import { ComponentBlock } from '@types';
import { types } from 'core/types';

import { AspectRatioBoxProps } from './index';
import { component } from './component';

export const block: ComponentBlock<'aspectRatio', AspectRatioBoxProps, any> = {
  id: 'aspectRatio',
  render: component,
  props: {
    px: {
      type: types.number,
    },
    py: {
      type: types.number,
    },
    ratio: {
      type: types.string,
    },
    borderColor: {
      type: types.string,
    },
    borderWidth: {
      type: types.string,
    },
    borderRadius: {
      type: types.string,
    },
  },
};
